module.exports = {
    methods: {
        // eslint-disable-next-line
        $route: window.route,

        getRoute(route = {}) {
            return this.$page.props.routePrefix + route;
        },

        $$route(route = {}, attributes = {} )  {
            return this.$route( this.$page.props.routePrefix + '.' + route, attributes );
        },

        $currency(number) {
            return new Intl.NumberFormat('de-DE', {style: 'currency',currency: 'EUR', minimumFractionDigits: 2}).format(number);
        },

        $date(dateTime) {
            // console.log(dateTime);
            return this.$moment(dateTime).format('DD.MM.YYYY');
        },
        $dateTime(dateTime) {
            // console.log(dateTime);
            return this.$moment(dateTime).format('DD.MM.YYYY HH:mm') + ' ' + this.$gettext('Uhr');
        },

        $readableStatus(status_id) {
            let status = this.$page.props.askForQuoteStatus.filter((status) => {
                return status.status_id === String(status_id);
            });
            return status[0]?.status_name;
        },

        $readableStatusClient(status_id) {
            let status = this.$page.props.askForQuoteStatusClient.filter((status) => {
                return status.status_id === String(status_id);
            });
            return status[0]?.status_name;
        },

        $readableStatusProducer(status_id) {
            let status = this.$page.props.askForQuoteStatusProducer.filter((status) => {
                return status.status_id === String(status_id);
            });
            return status[0]?.status_name;
        },

        $readableProducerStatus(status_id) {
            let status = this.$page.props.producerStatus.filter((status) => {
                return status.status_id === String(status_id);
            });
            return status[0]?.status_name;
        },

        $readableComplaintReason(reason_value) {
            let reason = this.$page.props.complaintReasons.filter((reason) => {
                return reason.value === String(reason_value);
            });
            return reason[0]?.text;
        },
        $readableRejectReason(reason_value) {
            let reason = this.$page.props.rejectReasons.filter((reason) => {
                return reason.value === String(reason_value);
            });
            return reason[0]?.text;
        },

        $readablePaymentType(payment_type) {
            let payment = String;
            switch(payment_type) {
                case 'BL_IV':
                    payment = this.$gettext('Rechnung');
                    break;
                case 'CC':
                    payment = this.$gettext('Kreditkarte');
                    break;
                case 'VA':
                    payment = this.$gettext('PayPal Express');
                    break;
                case 'OT_SO':
                    payment = this.$gettext('Sofortüberweisen (Deutschland)');
                    break;
                case 'OT_GP':
                    payment = this.$gettext('Giropay (Deutschland)');
                    break;
            }
            return payment;
        },

        $disabledTab(currentStatus, statusTab) {
            return currentStatus === 12 || currentStatus < 0 || currentStatus > statusTab;
        }
    },
};
